import { render, staticRenderFns } from "./SkeletonMiniWizardBottomBar.vue?vue&type=template&id=4402d264&"
import script from "./SkeletonMiniWizardBottomBar.vue?vue&type=script&lang=js&"
export * from "./SkeletonMiniWizardBottomBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports